import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    video: {},
    openModal: false,
    activeVideo: {}
};

const videosSlice = createSlice({
    name: "videos",
    initialState,
    reducers: {
        editVideo: (state, action) => {
            state.video = action.payload;
        },
        toggleModal: (state, action) => {
            state.openModal = action.payload
        },
        setActiveVideo: (state, action) => {
            state.activeVideo = action.payload
        },
    },
});

export const { editVideo, toggleModal, setActiveVideo } = videosSlice.actions;
export default videosSlice.reducer;
